import script from "./form-manufacturer.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-manufacturer.vue?vue&type=script&setup=true&lang=ts"

import "./form-manufacturer.vue?vue&type=style&index=0&id=3222f0f1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3222f0f1"]])

export default __exports__